import { IUser } from '../Interfaces/IUser';
import { IAction } from '../../../__core/Interfaces/IAction';
import APP_ACTIONS from './ActionTypes';

export const getUserSuccess = (user: IUser): IAction<IUser> => ({
  type: APP_ACTIONS.FETCH_USER,
  payload: user,
});
